import { MoviePlusIcon } from './MoviePlusIcon';

/**
 * author: Colton Wiscombe
 * id 543E83B1-B4CD-4D26-9813-A7F23C44AC5F
 * name movie-plus
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-plus.svg
 * tags
 * - Video / Movie 
 */
export const SlatePlusIcon = MoviePlusIcon;
export default SlatePlusIcon